import {getPayoutsInfo} from "../Util/queries";
import { PartnerPayouts } from "../Model/payoutObjects";
import { PAYOUT_INFO } from "../Reducers/payoutsReducer";

export const getPartnerPayoutInfo = () => async dispatch => {
    try {
        let response = await getPayoutsInfo();
        if (response.data === null || response.data === "" || response.status === 400) {
            response.data = [];
        }
        dispatch({
            type: PAYOUT_INFO,
            payload: new PartnerPayouts(response.data),
        })
    } catch (e) {
        console.error(e);
        dispatch({
            type: PAYOUT_INFO,
            payload: new PartnerPayouts([]),
        })
    }
}
